module.exports = "/_next/static/images/stars-180086d5bb1c596dacc0d0744217e207.png";